import { useEffect, useState } from "react";
import { lambdaErrorCheck } from "../../common/util/errorHandling";
import { useAppSelector } from "../../store";
import { storedLocale } from "../Authentication/util";
import { useGetFrontlineQOverviewQuery } from "../../services/FrontlineQ/frontlineQAPI";
import { QUALIFICATION_STATUS } from "../../common/enums/incentive-enums";
import { FrontlineQOverviewResponse } from "../../services/FrontlineQ/frontlineQAPI.types";
import { REQUIREMENT_NAME } from "../../common/enums/requirements";

export const defaultFrontlineQOverviewData = (): FrontlineQOverviewResponse => {
  return {
    IncentiveCalculation: {
      PaymentUnit: "",
      PotentialPYEarnings: "",
      TrackingFQs: "",
    },
    IncomeData: {
      PotentialPYEarnings: "",
      Status: QUALIFICATION_STATUS.NOT_QUALIFIED,
    },
    Requirements: {
      AnnualPPVRequirement: {
        Exempt: false,
        Met: false,
        Name: REQUIREMENT_NAME.PERSONAL,
        Targets: [],
        Volume: {
          Current: { Actual: 0, Formatted: "" },
          Target: { Actual: 0, Formatted: "" },
          Remaining: { Actual: 0, Formatted: "" },
        },
      },
      FQRequirement: {
        BaselineFQs: "",
        CurrentFQs: "",
        Exempt: false,
        Met: false,
        TrackingFQs: "",
      },
      FoundersPlatinumRequirement: {
        Exempt: false,
        Met: false,
        Name: REQUIREMENT_NAME.PERSONAL,
        Status: QUALIFICATION_STATUS.NOT_QUALIFIED,
      },
    },
    PaymentUnitDetails: {
      PinLevelColumnHeaderContentKeys: [],
      Rows: [],
    },
    CallResults: [],
    Error: [],
  };
};

export const FetchFrontlineQOverviewData = (period: string, isComingSoon: boolean) => {
  const { user } = useAppSelector((state) => state.boot);
  const shellConfig = useAppSelector((state) => state.boot.shellConfig);
  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetFrontlineQOverviewQuery(
    {
      abo: user.abo,
      aff: user.aff,
      period: period,
      isoCountryCode: user.isoCountryCode,
      isoCurrencyCode: shellConfig.isoCurrencyCode,
      locale: storedLocale(),
    },
    {
      skip: isComingSoon,
    },
  );

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [frontlineQOverviewData, setFrontlineQOverviewData] = useState<FrontlineQOverviewResponse>(
    defaultFrontlineQOverviewData(),
  );

  useEffect(() => {
    setIsLoading(isFetching);
    setErrorStatus(isError);
    if (!isFetching && !isError && payloadData) {
      setFrontlineQOverviewData(payloadData);
      const foundLambdaError = lambdaErrorCheck(payloadData.Error);
      setErrorStatus(foundLambdaError);
    }
  }, [isFetching, period, isError, payloadData]);

  return { isLoading, frontlineQOverviewData, errorStatus, refetch };
};
